export default function step05Reducer(
    state: any = {
        loading: false,
        done: false,
        error: null,
        response: [
            {
                'id': 1,
                'commission': 5.0,
                'excess': 500,
                'money': null,
                'glass': null,
                'cancellationCover': null,
                'defectiveTitle': null,
                'personalAccident': null,
                'unattendedVehicleCover': null,
                'terrorism': false,
                'shoplifting': false,
                'isIssued': true,
                'premium': null,
            },
        ],
        subjectivities: [],
        postSoftRef: null,
        creationDate: '',
        market: null,
        underwriter: null,
        softReferrals: {
            loading: true,
            done: false,
            error: null,
            response: [],
        },
        summary: {
            loading: false,
            done: false,
            error: null,
            response: {
                'clientName': '',
                'inceptionDate': '',
                'expiryDate': '',
                'policyTypeId': 1,
                'policyName': '',
                'policyNumber': '',
                'premium': 0,
                'commission': 0,
                'excess': 0,
                'settlementBasis': 1.5,
                'priceBasis': '',
                'totalSumInsured': 0,
                'operativeSections': [],
            },
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Get existing locations
         */
        case 'GET_STEP05_QUOTE_VAR_PENDING': {
            return { ...state, loading: true }
        }

        case 'GET_STEP05_QUOTE_VAR_REJECTED': {
            return { ...state, loading: false, error: action.payload }
        }

        case 'GET_STEP05_QUOTE_VAR_FULFILLED': {

            let resp = action.payload.quoteVariations
            let subjectivities = action.payload.subjectivities
            let creationDate = action.payload.creationDate
            let maxComi = action.payload.maxCommission
            let minComi = action.payload.minCommision
            let maxExcess = action.payload.maxExcession
            let minExcess = action.payload.minExcession
            let isExperiencedBroker = action.payload.isExperiencedBroker
            let excessionDefault = action.payload.excessionDefault

            resp.sort(function (a: any, b: any) {
                return parseFloat(a.id) - parseFloat(b.id)
            })

            return {
                ...state,
                loading: false,
                done: true,
                error: null,
                response: resp,
                subjectivities: subjectivities,
                creationDate: creationDate,
                maxCommission: maxComi ? maxComi : '',
                minCommission: minComi ? minComi : '',
                maxExcession: maxExcess ? maxExcess : '',
                minExcession: minExcess ? minExcess : '',
                excessionDefault: excessionDefault ? excessionDefault : '',
                isExperiencedBroker: isExperiencedBroker ? isExperiencedBroker : '',
            }
        }

        /**
         *     Get existing locations
         */
        case 'RESET_STEP05_QUOTE_VAR': {
            return {
                ...state,
                loading: false,
                done: false,
                error: null,
                response: [
                    {
                        'id': 1,
                        'commission': 5.0,
                        'excess': 500,
                        'money': null,
                        'glass': null,
                        'cancellationCover': null,
                        'defectiveTitle': null,
                        'personalAccident': null,
                        'unattendedVehicleCover': null,
                        'terrorism': false,
                        'shoplifting': false,
                        'isIssued': true,
                        'premium': null,
                    },
                ],
                market: null,
                underwriter: null,
            }
        }

        /**
         *     Check for soft referrals
         */
        case 'CHECK_STEP05_SOFT_REF_PENDING': {
            return {
                ...state,
                softReferrals: {
                    done: false,
                    loading: true,
                    error: null,
                    response: [],
                },
            }
        }

        case 'CHECK_STEP05_SOFT_REF_REJECTED': {
            return {
                ...state,
                softReferrals: {
                    done: false,
                    loading: false,
                    error: action.payload,
                    response: [],
                },
            }
        }

        case 'CHECK_STEP05_SOFT_REF_FULFILLED': {

            let softReferrals = action.payload.softReferrals

            return {
                ...state,
                softReferrals: {
                    loading: false,
                    done: true,
                    error: null,
                    response: softReferrals,
                },
            }
        }

        case 'REMOVE_STEP05_SOFT_REF': {
            return {
                ...state,
                postSoftRef: null,
            }
        }

        /**
         *      Set response from Soft Ref reasons
         */
        case 'POST_STEP05_SOFT_REF_FULFILLED': {
            return {
                ...state,
                postSoftRef: true,
            }
        }

        /**
         *      Set 'quote from another market' option
         */
        case 'SET_ANOTHERMARKET_FULFILLED': {
            return { ...state, market: true }
        }

        /**
         *      Set 'quote from another market' option
         */
        case 'SET_UNDERWRITER_FULFILLED': {
            return { ...state, underwriter: true }
        }

        case 'GET_POLICY_SINGLE_PENDING': {
            return {
                ...state,
                summary:
                {
                    ...state.summary,
                    loading: true,
                },
            }
        }

        case 'GET_POLICY_SINGLE_REJECTED': {
            return {
                ...state,
                summary:
                {
                    ...state.summary,
                    loading: false,
                    error: action.payload,
                },
            }
        }

        case 'GET_POLICY_SINGLE_FULFILLED': {
            return {
                ...state,
                summary:
                {
                    ...state.summary,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload.policy,
                },
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/quote/step05.ts